import { ResponseContext, SmartProblemDetails } from "../../../@api";

import { translationKeys } from "../../models/app-translation-keys";
import { IMiddelware } from "../../models/interfaces/middelware.interface";
import { GlobalErrorsStore } from "../../stores";

export class RateLimitHandlingMiddleware implements IMiddelware {
  public readonly handledHttpStatusCodes = [429];

  constructor(private readonly globalErrorsStore: GlobalErrorsStore) {}

  public async post(context: ResponseContext): Promise<void> {
    if (this.handledHttpStatusCodes.includes(context.response.status)) {
      await this.setError(context);
    }
  }

  public resetError(): void {
    this.globalErrorsStore.removeError(translationKeys.thread.error.requestLimitReached.Text);
    this.globalErrorsStore.removeError(translationKeys.thread.error.requestLimitReached.TextWithRetryAfter);
  }

  public async setError(context: ResponseContext): Promise<void> {
    if (!this.handledHttpStatusCodes.includes(context.response.status)) {
      return;
    }

    let problemDetails: SmartProblemDetails | undefined;
    try {
      problemDetails = (await context.response.clone().json()) as SmartProblemDetails;
    } catch {
      problemDetails = undefined;
    }

    const retryAfter =
      typeof problemDetails?.retryAfter === "number" &&
      Number.isFinite(problemDetails.retryAfter) &&
      problemDetails.retryAfter >= 0
        ? problemDetails.retryAfter
        : undefined;

    const errorKey =
      retryAfter === undefined
        ? translationKeys.thread.error.requestLimitReached.Text
        : translationKeys.thread.error.requestLimitReached.TextWithRetryAfter;

    const errorData = {
      ...(retryAfter === undefined ? {} : { seconds: retryAfter }),
    };

    this.resetError();
    this.globalErrorsStore.addErrorIfNotExists(errorKey, errorData, true);
  }
}
